<template lang="pug">
.Loader
  v-card.rounded-1.elevation-20(v-if="value")
    v-container
      v-layout(justify-center)
        v-progress-circular(color="primary", indeterminate, :size="100")
      v-layout.pt-4(justify-center)
        h2.primary--text Loading ...
  slot(v-else)
</template>

<script>
export default {
  name: 'Loader',
  props: {
    value: {
      required: true
    }
  },
  data: () => ({})
}
</script>

<style lang="sass" scoped>
.Loader
  width: 100%
</style>
